import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CourseDescriptionV3 from '../../../components/courseDescriptionV3';
import CourseDescriptionV3BG from '../../../images/ComponentImages/CourseDescriptionV3BG.png';
import Banner from '../../../components/banner';
import BannerBG from '../../../images/ComponentImages/banner03.png';
import CourseLandingScreen from '../../../components/courseLandingScreen';
import CourseDescription from '../../../components/courseDescription';
import CourseDescriptionV2 from '../../../components/courseDescriptionV2';
import CourseDescriptionV2BG from '../../../images/ComponentImages/CourseDescriptionV201.png';
import WarningBlock from '../../../components/warningBlock';
import InfoBlock from '../../../components/infoBlock';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CourseLandingScreen title='Crafty Home Workouts' />
			<Banner mt={true} bgImage={BannerBG} title={'There is always room for improvement.'} alignment='right' />
			<CourseDescriptionV3
				mt={true}
				titles={['You Can’t Make It to the Gym?', 'Don’t Have A Gym?', 'Still Want to Workout?']}
				texts={[
					'Well Now, you will never miss a workout ever again.',
					'These home workouts are meant to help you with time and consistency. It’s meant to work around your busy and rugged schedule.',
					'There is a bevy of workouts you can individually choose from. These workouts are complex and easy to learn. You just have to meet the workout plan halfway with personal responsibility and self-perseverance for results to reach the maximum.',
				]}
				my={true}
				BGImage={CourseDescriptionV3BG}
			/>
			<CourseDescription
				texts={[
					'You have to understand that you are doing this for yourself, not for anyone else. Crafty Home Workouts are meant for you to get in then out, saving you so much time for other things you want to do throughout the day. Crafty Home Workouts revolve around a time crunch when you want something done in a small amount of time. Crafty Home Workouts does this for you. It is effective to its core.',
					'Crafty Home Workouts revolve around a time crunch when you want something done in a small amount of time. Crafty Home Workouts does this for you. It is effective to its core.',
				]}
			/>
			<InfoBlock mt={true} texts={['CraftyHomeWorkouts can be performed anytime & anywhere!']} />
			<CourseDescriptionV2
				mt={true}
				title='Simple     Fast     Effective'
				texts={[
					'The CraftyHomeWorkouts Program will push your body to its limits. It will hit you from all directions developing your functionality, cardiovascular and strength.',
					'If you feel out of shape because you just came home from a walk or just carrying groceries, you need to look again through your life with different scope.',
					"You need to start making better choices for yourself because your body is like an engine that is functional but if you neglect it, your engine will get rusty and sooner or later will just fail on you. If you don't take care of your body, those privileges you worked hard for will be taken from you. Your mind is powerful but your body is a component of your mind. They both go hand in hand, you need to get your act together and when performing these exercises.These exercises will help you in your overall wellness. You will look back on this and thank yourself later on.",
				]}
				bgImage={CourseDescriptionV2BG}
			/>
			<CourseDescription
				mt={true}
				title='Instructions'
				texts={[
					'* Before starting your workout look at the Workout  Plan and double check if the exercises involve (Dumbbells, KettleBells, Loop Bands, or PullUp Bars or Resistance Bands.) You can add or subtract the items if the exercises are too difficult.',
					'* You can perform the Workout Plan by Sets (finishing that one exercise all at once with required set provided then moving forward to the next exercise) or go by Rounds (going to the next exercise then repeating all over again by how many rounds are required) whichever works best for you.)',
					'* Finish the (A) Exercise first then presume to the Core Exercises.',
					'* 30sec Rest Period when appropriate.',
					'* Focus on the Workout! Nothing More, Nothing Less.',
				]}
			/>
			<CourseDescription
				mt={true}
				title='Requirements'
				texts={[
					'5lbs-10lbs-15lb dumbbells ).',
					'KettleBells (recommendation.',
					'Loop Bands/ Hip Circle Bands.',
					'PullUp Bar access (recommendation).',
					'Resistance Bands',
				]}
			/>
			<CourseDescription
				mt={true}
				title='Acronyms'
				texts={[
					'KB~KettleBell.',
					'DB~Dumbell',
					'DL~DeadLifts',
					'RDL~Romanian Deadlift',
					'LB~Loop Bands',
					'RB~Resistance Bands',
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
